import { ConfigsService } from "./configs.service";
import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";

@Injectable()
export class TrazPaciente {
  constructor(private http: Http, private config: ConfigsService) {}

  // serviço para trazer os pacientes
  lista(parametro): Observable<any> {
    // se o parametro for 1, vai pegar os pacientes do hospital
    if (parametro == 1) {
      var sHospital = JSON.parse(sessionStorage.getItem("hospital"));
      var codHospital = sHospital.cod_hospital;

      return this.http
        .get(`${this.config.urlApi}/pacientes/hospital/${codHospital}`)
        .map((response) => response.json());

      // se o parâmetro for 2, traz todos os pacienets
    } else if (parametro == 2) {
      return this.http
        .get(`${this.config.urlApi}/pacientes`)
        .map((response) => response.json());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/trazPaciente.service.ts